module.exports = __webpack_public_path__ + "img/routes.a35ef20c.svg";